<!-- Componente se utiliza para notificar operacion fallida -->

<div class="pdt20 pdb10 pdl30 pdr30">
    <div fxLayout="column" fxLayoutAlign=" center">
        <mat-icon class="linkIcon ftxxxl red-5">warning</mat-icon>
        <p class="mgt05 gray-10">Operación fallida</p>
    </div>
</div>
